import { Grid, DialogActions, DialogContent, Button, FormControl, Typography } from '@mui/material';
import { DialogCustom, DialogTitleCustom, FieldWrap } from '@tap/mui-ui';
import { IApiComment, userService } from '@tap/data-providers';
import { useComment } from './useComment';
import { useState } from 'react';
import { ICancelDialogResult, IDialogProps } from '@tap/tap-ui';
import { CommentEditor } from './CommentEditor';
import { dateTimeHelper } from '@tap/utils';

/**
 *  Диалог: редактировать комментарий
 */

type IEditCommentDialogProps = IDialogProps<{
    comment: IApiComment,
    documentKey: string,
    editCommentCallback: () => void,
}, ICancelDialogResult>;

export const EditCommentDialog = ({
    data,
    isOpen,
    handleClose,
}: IEditCommentDialogProps) => {

    const [isSaved, setIsSaved] = useState<boolean>(false);

    const commentState = useComment({
        commentId: data.comment.id,
        inputMessage: data.comment.message,
    });

    const handleEditComment = async () => {
        try {
            setIsSaved(true);
            await commentState.editComment();
            data.editCommentCallback && data.editCommentCallback();
            handleClose({ isCancel: true });
        } catch (error) {
            console.log(error)
        } finally {
            setIsSaved(false);
        }
    }

    const handleCancel = () => {
        handleClose({ isCancel: true });
    }


    return (
        <DialogCustom
            handleClose={handleCancel}
            open={isOpen}
            sx={{ overflow: 'visible' }}
        >

            <DialogTitleCustom
                primaryText={'Редактировать комментарий'}
            />

            <DialogContent sx={{ overflow: 'visible', minHeight: '290px' }}>

                <Grid container spacing={2}>

                    <FieldWrap label={'Автор'}>
                        <Typography>
                            {data.comment?.author
                                ? userService.getUserFIO(data.comment.author)
                                : data.comment.authorId
                            }
                        </Typography>
                    </FieldWrap>

                    <FieldWrap label={'Создан'}>
                        <Typography>
                            {dateTimeHelper.format(data.comment.createdAtUtc, 'dd MMM yyyy в HH:mm', true)}
                        </Typography>
                    </FieldWrap>

                    <FieldWrap
                        label={'Комментарий'}
                        wrapLabelStyle={{
                            verticalAlign: 'top',
                            paddingTop: '6px',
                        }}
                        wrapStyle={{
                            marginBottom: '15px',
                        }}
                    >
                        <FormControl fullWidth>
                            <CommentEditor {...commentState} />
                        </FormControl>
                    </FieldWrap>

                </Grid>
            </DialogContent>

            <DialogActions>
                <Grid container justifyContent='flex-end'>

                    <Button
                        disableElevation
                        type='button'
                        variant='contained'
                        color='primary'
                        sx={{ mr: 2 }}
                        onClick={() => handleEditComment()}
                        disabled={
                            !commentState.message
                            || commentState.message.length === 0
                            || isSaved
                        }
                    >
                        Сохранить
                    </Button>

                    <Button
                        disableElevation
                        type='button'
                        variant='text'
                        color='primary'
                        onClick={handleCancel}
                    >
                        Отмена
                    </Button>

                </Grid>
            </DialogActions>

        </DialogCustom >
    );
}
